import { render, staticRenderFns } from "./PressRoom.vue?vue&type=template&id=1b67f348&"
import script from "./PressRoom.vue?vue&type=script&lang=js&"
export * from "./PressRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports